import { jsx as _jsx } from "react/jsx-runtime";
import CheckmarkFilled16 from '@carbon/icons-react/es/checkmark--filled/16';
import Information16 from '@carbon/icons-react/es/information/16';
import InformationFilled20 from '@carbon/icons-react/es/information--filled/20';
import ViewOff16 from '@carbon/icons-react/es/view--off/16';
// eslint-disable-next-line no-restricted-imports
import { Alert as AntAlert } from 'antd';
import styled, { css } from 'styled-components';
import { switchProp, prop } from 'styled-tools';
const renderIcon = (type)=>{
    switch(type){
        case 'private':
            return /*#__PURE__*/ _jsx(ViewOff16, {});
        case 'warning':
        case 'info':
            return /*#__PURE__*/ _jsx(InformationFilled20, {});
        case 'success':
            return /*#__PURE__*/ _jsx(CheckmarkFilled16, {});
        case 'danger':
            return /*#__PURE__*/ _jsx(Information16, {});
        default:
            return /*#__PURE__*/ _jsx(Information16, {});
    }
};
export const Alert = styled(AntAlert).attrs(({ showIcon, type })=>({
        icon: showIcon ? renderIcon(type) : null,
        type: type || 'info'
    }))`
  ${switchProp(prop('type', 'default'), {
    warning: css`
      background: var(--warning-bg-color);
      border-color: var(--warning-border-color);

      .ant-alert-icon {
        color: var(--warning-border-color);
      }

      .ant-alert-message {
        width: 80%;
        color: var(--gray-80);
      }
    `,
    private: css`
      background: var(--private-01);
      border-color: var(--private-01);

      .ant-alert-icon {
        color: var(--gray-80);
      }

      .ant-alert-message {
        width: 80%;
        color: var(--gray-80);
      }
    `,
    info: css`
      background: var(--blue-10);
      border-color: var(--blue-30);

      .ant-alert-icon {
        color: var(--blue-60);
      }
    `,
    danger: css`
      background: var(--red-10);
      border: 1px solid var(--red-30);
      .ant-alert-icon {
        color: var(--red-50);
      }
    `,
    error: css`
      background: var(--red-10);
      border: 1px solid var(--red-30);
      .ant-alert-icon {
        color: var(--red-50);
      }
    `,
    success: css`
      background: var(--green-10);
      border: 1px solid var(--green-30);
      .ant-alert-icon {
        color: var(--green-50);
      }
    `,
    default: css`
      background: var(--gray-10);
      border-color: transparent;

      .ant-alert-icon {
        color: var(--gray-50);
      }

      .ant-alert-message {
        width: 80%;
        color: var(--gray-80);
      }
    `
})};

  align-items: flex-start;
  display: flex;
  padding: var(--spacing-05);
  border-radius: 0;

  .ant-alert-icon {
    left: unset;
    margin: var(--spacing-01) var(--spacing-05) 0 0;
    position: relative;
    top: unset;
  }

  :root[data-new-theme-enabled='true'] & {
    border: none;
    border-radius: var(--border-radius-small);
    padding: var(--spacing-05);

    .ant-alert-icon {
      margin-right: var(--spacing-03);
      margin-top: 0px;
    }
  }
`;
